import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG_TOKEN } from '../../shared/utils/app-config.token';
import { IConfig } from '../interfaces/app-config.interface';

@Injectable({
  providedIn: 'root',
})
export class AppConfig {
  constructor(@Inject(APP_CONFIG_TOKEN) public config: IConfig) {}
}
